export const DADOS_CHAMADA = 'dadoschamada';
export const DESTINO_RINGANDO = 'destinoringando';
export const FIM_CHAMADA = 'fimchamada';
export const RESPOSTA_FAZER_CHAMADA = 'respfazerchamada';
export const RESULT_DESLOGAR = 'resultdeslogar';
export const RESULT_DESPAUSAR = 'resultdespausar';
export const RESULT_LOGAR = 'resultlogar';
export const RESULT_PAUSAR = 'resultpausar';
